
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_h11ix_ni7y_4",
  "icon-flex-height": "awsui_icon-flex-height_h11ix_ni7y_10",
  "size-small": "awsui_size-small_h11ix_ni7y_35",
  "size-small-mapped-height": "awsui_size-small-mapped-height_h11ix_ni7y_39",
  "size-normal": "awsui_size-normal_h11ix_ni7y_53",
  "size-normal-mapped-height": "awsui_size-normal-mapped-height_h11ix_ni7y_57",
  "size-medium": "awsui_size-medium_h11ix_ni7y_71",
  "size-medium-mapped-height": "awsui_size-medium-mapped-height_h11ix_ni7y_75",
  "size-big": "awsui_size-big_h11ix_ni7y_89",
  "size-big-mapped-height": "awsui_size-big-mapped-height_h11ix_ni7y_93",
  "size-large": "awsui_size-large_h11ix_ni7y_107",
  "size-large-mapped-height": "awsui_size-large-mapped-height_h11ix_ni7y_111",
  "variant-normal": "awsui_variant-normal_h11ix_ni7y_125",
  "variant-disabled": "awsui_variant-disabled_h11ix_ni7y_128",
  "variant-inverted": "awsui_variant-inverted_h11ix_ni7y_131",
  "variant-subtle": "awsui_variant-subtle_h11ix_ni7y_134",
  "variant-warning": "awsui_variant-warning_h11ix_ni7y_137",
  "variant-error": "awsui_variant-error_h11ix_ni7y_140",
  "variant-success": "awsui_variant-success_h11ix_ni7y_143",
  "variant-link": "awsui_variant-link_h11ix_ni7y_146",
  "badge": "awsui_badge_h11ix_ni7y_150"
};
  